<div class="tabs"
     [ngClass]="getTabsClasses()"
     [ngStyle]="getTabsStyles()"
     (mouseleave)="onMouseLeave()">
    <div class="shadow"
         [ngStyle]="shadowStyles(false)"></div>
    <div class="active-shadow"
         [ngStyle]="shadowStyles(true)"></div>
    <app-tab *ngFor="let tab of tabs; let i = index"
             [tab]='tab'
             [tabIndex]='i'
             [activeTab]='activeTab'
             [tabStyle]='tabStyle'
             [tabActiveStyle]='tabActiveStyle'
             [tabHoveredStyle]='tabHoveredStyle'
             (hoverEvent)="onTabHover($event)"
             (activeEvent)="onTabActive($event)"
             (tabChangeEvent)="onTabChange($event)"
             (clickEvent)="onTabClick($event)"></app-tab>
</div>
